var _defs, _rect, _polyline, _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew191({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#fff;stroke-linejoin:round;}.a{stroke-width:0.52px;}.b{stroke-width:0.42px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.5,
    y: 0.73,
    width: 11.96,
    height: 11.96
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "8.12 2.85 5.54 5.43 7.76 7.65 4.84 10.57"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.49,12.71l0,3s.67,0,1.85-1.2,1.19-1.84,1.19-1.84Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 12.49,
    y1: 12.71,
    x2: 14.31,
    y2: 14.53
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew191);
export default __webpack_public_path__ + "static/media/Symbolpack_New_191.317c158dd8536042309941e542d93765.svg";
export { ForwardRef as ReactComponent };